class SampaHero extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.viewport = this.querySelector('.sampa-hero__viewport');
    this.track = this.querySelector('[data-sampa-track]');
    this.slides = Array.from(this.querySelectorAll('[data-sampa-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-sampa-dot]'));
    this.index = 0;
    if (!this.track || !this.viewport || this.slides.length === 0) return;
    this.resizeObserver = new ResizeObserver(() => this.syncHeight());
    this.slides.forEach((slide) => this.resizeObserver.observe(slide));
    if (this.slides.length < 2) {
      this.goTo(0);
      return;
    }
    this.querySelector('[data-sampa-previous]')?.addEventListener('click', () => this.goTo(this.index - 1, true));
    this.querySelector('[data-sampa-next]')?.addEventListener('click', () => this.goTo(this.index + 1, true));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index, true)));
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
    this.goTo(0);
    this.start();
  }

  syncHeight() {
    const activeSlide = this.slides[this.index];
    if (!activeSlide || !this.viewport) return;
    const height = activeSlide.getBoundingClientRect().height;
    if (height > 0) this.viewport.style.height = `${Math.round(height)}px`;
  }

  goTo(nextIndex, userInitiated = false) {
    this.index = (nextIndex + this.slides.length) % this.slides.length;
    this.track.style.transform = `translate3d(-${this.index * 100}%,0,0)`;
    this.slides.forEach((slide, index) => {
      const active = index === this.index;
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      if ('inert' in slide) slide.inert = !active;
    });
    this.dots.forEach((dot, index) => dot.setAttribute('aria-current', index === this.index ? 'true' : 'false'));
    window.requestAnimationFrame(() => this.syncHeight());
    if (userInitiated) {
      this.stop();
      this.start();
    }
  }

  start() {
    if (this.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.stop();
    const delay = Math.max(Number(this.dataset.speed) || 6000, 3000);
    this.timer = window.setInterval(() => this.goTo(this.index + 1), delay);
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  }

  disconnectedCallback() {
    this.stop();
    this.resizeObserver?.disconnect();
  }
}

if (!customElements.get('sampa-slider')) customElements.define('sampa-slider', SampaHero);
